import { toast } from "react-toastify";
import { BASE_URL } from "../../global";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import moment from "moment";

export const handleWithdrawApproval = async (clientPairs) => {
  const isConfirmed = window.confirm(
    "Are you sure you want to withdraw the approval?"
  );

  if (!isConfirmed) return;

  const userId = localStorage.getItem("id");
  // Extract ids only for the UPDATE query
  const idString = clientPairs.map((p) => p.id).join(",");

  try {
    // Perform the update for the certificates (single or multiple)
    await axiosWithToken.post(BASE_URL + "dynamic", {
      query: `UPDATE certificates SET status = 1, approvedBy = NULL, approvedDate = NULL, reviewedBy = NULL, reviewedDate = NULL, signedBy = NULL, signedDate = NULL,rejectedBy = NULL, witnessBy = NULL, witnessDate = NULL WHERE id IN (${idString});`
    });

    // Audit logs request
    for (const { id, clientId } of clientPairs) {
      const payload = {
        clientId,
        type: "certificates",
        identifier: id,
        action: "withdraw",
        userId,
        change_date: moment(new Date().toISOString()).format("YYYY-MM-DD HH:mm:ss"),
      };
      try {
        await axiosWithToken.post(BASE_URL + "audit_log", payload);
      } catch (err) {
        console.log("certificate withdrawAudit error:", err);
      }
    }
    toast("Certificate withdraw successfully!");
    setTimeout(() => window.location.reload(false), 1000);
  } catch (err) {
    console.log("Error: ", err);
  }
};
